// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Caig","largestCol":"styles_largestCol__2_AeC","smallestCol":"styles_smallestCol__19Z_p"};